const ALL_STORE_ROLES = new Set(["president", "manager"]);

export function canAccessAllStores(user) {
  return ALL_STORE_ROLES.has(user?.role);
}

export function canExportPayrollCsv(user) {
  // 勤怠承認と同じ役職境界。将来は個別権限判定へ差し替える。
  return ALL_STORE_ROLES.has(user?.role);
}

export function getVisibleStores(user, stores) {
  if (canAccessAllStores(user)) return stores;

  const userStoreId = user?.store || user?.store_id || user?.storeId || "kasama";
  return stores.filter(store => store.id === userStoreId);
}

export function canViewAppTab(user, tabId, defaultAllowed = false) {
  if (tabId === "minutes") return true;
  return user?.perms?.[tabId] ?? defaultAllowed;
}
